export const textData = [
	["为宝鸡建设关中平原城市群副中心城市贡献智慧和力量", ""],
	["践行文明公约，争当文明有礼的宝鸡人", ""], 
	["关爱父母长辈，尊老、敬老", ""],
	["重视家庭教育，传好家训、立好家规、守好家风", ""],
	["培养子女自信自强、勤俭节约、敬老爱幼", ""], 
	["感谢生命中出现的每一位师者", ""],
	["言必信、行必果", ""],
	["学雷锋，做好事", ""], 
	["无偿献血，拯救生命", ""], 
	["有困难，找志愿者；有时间，当志愿者。", ""], 
	["积极参与捐资助学、扶贫济困、关爱他人等公益活动", ""],
	["节约用水用电，爱惜粮食。", ""], 
	["公共场合，不大声喧哗，不讲粗话脏话。", ""],
	["珍惜能源，绿色出行。", ""],
	["爱护树木，保护花草。", ""], 
	["从我做起，保护环境、呵护生态、爱护公物。", ""], 
	["倒垃圾，先分类。", ""],
	["读好书，写好字，做好人。", ""], 
	["文明上网，不造谣、不信谣、不传谣。", ""],
	["不在网上谩骂、诋毁、诽谤他人。", ""],
	["远离色情、暴力、恐怖信息。", ""],
	["斑马线前礼让行人，不抢道先行。", ""],
	["邻里和睦，不传闲话，不闹纠纷。", ""],
	["不攀比、不浪费，红事、白事俭办。", ""], 
	["绿色殡葬、文明祭扫，不在山头和林地焚烧纸钱、抛洒祭品。", ""],
	["乔迁、升学，不办酒席、不请客、不送礼。", ""], 
	["相信科学，不迷信。", ""], 
	["爱岗敬业，诚实守信，奉献社会。", ""], 
	["遇到不良现象，敢于主持正义。", ""], 
	["不闯红灯，不乱穿马路，不翻越护栏。", ""]
]
